import React from 'react';
import Select, { selectType } from 'Components/Select';
import RowsSelector from 'Components/RowsSelector';
import YearPicker from 'Components/YearPicker';

export default class FiltersSection extends React.Component {
  render() {
    const {
      outCount, handleRowsSelect, rowsCount,
      currentModelYear, handleSelectFilter, filterState,
      statuses
    } = this.props;

    return (
      <section className='list-scene__utility-section-wrapper'>
        <section className='list-scene__utility-section-filters-wrapper'>
          <div className='list-scene__utility-section-filters-header'>Filter</div>

          <Select
            label='by Status'
            type={selectType.listFilter}
            withoutSearch
            defaultItem={statuses.find(status => status.value === filterState.status)}
            placeholder='All'
            selectionList={statuses}
            itemNameIndicator='name'
            handleSelect={handleSelectFilter('status')}
          />

          <YearPicker
            endYear={+currentModelYear + 1}
            yearPickAction={handleSelectFilter('year')}
            year={+filterState.year}
            withAllOption
            width={160}
            height={18}
          />
        </section>

        <section className='list-scene__utility-section-rows-select-wrapper'>
          <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowsSelect} selectedRowsCount={rowsCount} />
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/List/FiltersSection.jsx